import { Container, Row, Col, Button } from 'react-bootstrap';
import './projectgallery.css';
import { useEffect, useState } from 'react';
import Loader from '../../../Loader';
import { useGalleryStore } from '../../../../store/useGalleryStore';

function GalleryBanner() {
  const { banner, getBanner } = useGalleryStore()
  const [loading, setLoading] = useState(false)

  const fetchBannerData = async () => {
    setLoading(true)
    await getBanner()
    setLoading(false)
  }

  useEffect(() => {
    if (!banner) {
      fetchBannerData()
    }
  }, [banner, getBanner])
  return (
    <div>
      <Loader loading={loading}>
        <div className="gallery-banner-section" style={{
          "--project-bg": banner?.image ? `url(${banner.image})` : ""
        }}>
          <div className="gallery-banner-overlay" />
          <Container className="theme-container">
            <Row className="align-items-center">
              <Col md={8} lg={6}>
                <div className='gallery-banner-content'>
                  <p className="section-subtitle mb-xl-2 mb-1">
                    {banner?.subTitle}
                  </p>
                  <h2 className="section-sub-title mb-xl-3 mb-2">
                    {banner?.title}
                  </h2>
                  <p className="gallery-banner-description fontsize-20">
                    {banner?.description}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Loader>
    </div>
  )
}

export default GalleryBanner
